module.exports = __webpack_public_path__ + "static/media/scalpel-path.2ca18a7c.svg";